import React, { useState, useRef } from "react";
import { authenticationService } from "../../services/AuthinticationService";
import { useNavigate } from "react-router-dom";
import { TextInput } from "../../components/input/TextInput";
import utils from "../../utils/utils";
import { FormBuilder } from "../../components/forms/FormBuilder";
import { Error } from "../../components/forms/Error";
import formData from "../../components/forms/formsData.json";
import ReCAPTCHA from "react-google-recaptcha";

export function ForgotPassword() {
  const [forgotPasswordInput, setForgotPasswordInput] = useState({
    Email: "",
  });
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [formType, setFormType] = useState(() => structuredClone(formData["forgotPassword"]));
  const [isLoading, setIsLoading] = useState(true);
  const [BackendErrors, setBackendErrors] = useState(null);
  const [BackendLabel, setBackendLabel] = useState(null);

  const inputClassName =
    "bg-white rounded-lg  h-[3rem] w-[23rem] bg-transparent font-Poppins text-lg shadow-lg ";
  const recaptchaRef = useRef(null);
  const recaptchaPromiseRef = useRef(null);

  const SubmitFunc = async () => {
    let token;

    try {
      token = await new Promise((resolve, reject) => {
        recaptchaPromiseRef.current = resolve;

        recaptchaRef.current.reset();
        recaptchaRef.current.execute();

        setTimeout(() => {
          recaptchaPromiseRef.current = null;
          reject(new Error("reCAPTCHA timeout"));
        }, 10000);
      });
    } catch (e) {
      setBackendErrors("reCAPTCHA verification failed. Please try again.");
      return;
    }

    if (!token) {
      setBackendErrors("reCAPTCHA verification is required.");
      return;
    }

    let response = await authenticationService.forgetPass(
      forgotPasswordInput,
      token,
    );
    if (response && response.status < 400) {
      sessionStorage.setItem("fpUserEmail", forgotPasswordInput["Email"]);

      //
      // let confirm = await AlertConfirm({
      //     proceedLabel: 'Back to login',
      //     cancelLabel: 'none',
      //     options: {
      //         hasSVG: true,
      //         svgName: "greenOk",
      //         titleColorBlack: false,
      //         alertSize: 'w-[24.375rem] h-[13.625rem]'
      //     },
      //
      // }, "Use your new password to log in. ", `Email Sent!`)

      navigate("/verificationCode", {});
    }
  };

  const handleChange = async (event) => {
    const name = event.target.name;
    const value = event.target.value;

    // Update inputs immutably
    setForgotPasswordInput((prev) => ({ ...prev, [name]: value }));

    // Clone formType before modifying
    const form = structuredClone(formType);

    switch (name) {
      case "Email":
        if (value && !utils.mailValidation(value)) {
          setError({ Email: true });
          setIsError(true);
          form[0]["error"] = "Please enter valid Email address";
        } else if (!value) {
          form[0]["error"] = "Please enter Email address";
          setError({ Email: true });
          setIsError(true);
        } else {
          setError({ Email: false });
          setIsError(false);
          form[0]["error"] = "";
        }
        break;
      default:
        setIsError(false);
    }
    setFormType(form);
    setBackendErrors(null);
  };

  const handleRecaptchaChange = (value) => {
    if (recaptchaPromiseRef.current) {
      recaptchaPromiseRef.current(value);
      recaptchaPromiseRef.current = null;
    }
  };

  return (
    <div
      className={
        "p-[68px_38.5px_0px_38.5px] rounded-[32px] flex flex-col justify-self-center items-center self-center justify-start w-password h-password gap-[18px] bg-gray-800-opacity-30 border-gradient-custom "
      }
    >
      <div className="w-full z-10">
        <div className={" flex-col flex gap-1 items-center mb-[7px]"}>
          <TextInput
            text={"Forgot password?"}
            className={"text-white text-[30px] font-medium"}
          />
          <TextInput
            text={"enter your Email below to receive a code"}
            className={"text-[16px] text-white text-opacity-50"}
          />
        </div>

        <div className={"flex flex-col items-center w-full p-0"}>
          <FormBuilder
            data={formType}
            formData={forgotPasswordInput}
            onChange={(e) => handleChange(e)}
            containerClassName={"flex-col flex w-full h-full items-center z-10"}
            inputClassName="bg-black bg-opacity-30 bg-blend-luminosity custom-input rounded-[10px] h-[56px] w-[429px] z-20 text-[#999999] font-normal"
            isShown={error}
            isError={isError}
          />
        </div>
      </div>

      {BackendErrors && (
        <div className={"w-full text-left mt-2 ml-24"}>
          <Error message={BackendErrors} isShown={BackendErrors} />
        </div>
      )}
      {BackendLabel && (
        <div className={"w-full text-left mt-2 ml-24"}>
          <TextInput
            text={BackendLabel}
            className={
              " mt-[0.313rem] text-[#999996] leading-trim font-Poppins text-base font-normal leading-normal"
            }
          />
        </div>
      )}

      <div className={"mt-[0px] z-10 cursor-pointer"}>
        <button
          type="button"
          onClick={() => SubmitFunc()}
          disabled={
            !forgotPasswordInput["Email"] ||
            (forgotPasswordInput["Email"] &&
              !utils.mailValidation(forgotPasswordInput["Email"]))
          }
          className="rounded-[10px] button-glow bg-opacity-30 flex w-[429px] h-[56px] justify-center items-center flex-shrink-0 text-white
                            font-Poppins text-lg font-[500] text-[16px]"
        >
          Send
        </button>
      </div>
      <div
        className={
          "w-full font-normal text-white z-10 mt-[.45rem] text-center text-base " +
          "text-base font-normal leading-normal "
        }
      >
        Back to
        <span
          className="
      link-text
        "
          onClick={() => navigate("/")}
        >
          Login
        </span>
      </div>
      <div className={"hidden"}>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          size="invisible"
          onChange={handleRecaptchaChange}
        />
      </div>
    </div>
  );
}
